<template>
  <div 
    @click="handleButtonClick"
    class="cursor-pointer border"
    :class="SvgControl.value == value ? 'border-primary' : 'border-dull'">
    <slot />
  </div>
</template>

<script>

export default {
  name: 'SvgButton',

  props: {
    value: {
      type: undefined,
      default: ''
    }
  },

  inject: [ 'SvgControl' ],

  methods: {
    handleButtonClick () {
       this.SvgControl.captureButtonClick(this.value)
    }
  }

}

</script>